import {
  ChevronDown,
  Gift,
  Sparkles,
  Star,
  Ticket,
  Wallet,
  Dices,
  Trophy,
  Spade,
  Crown,
} from 'lucide-react';

export const navItems = [
  {
    id: 'buy-lotto',
    label: 'ซื้อหวย',
    icon: Ticket,
    children: [
      { href: '/lao', label: 'หวยลาวพัฒนา', icon: Crown, badge: 'หลัก' },
      { href: '/', label: 'ซื้อลอตเตอรี่', icon: Star },
      { href: '/yiki', label: 'หวยยี่กี', icon: Dices },
      { href: '/tickets', label: 'หวยของฉัน', icon: Ticket },
    ],
  },
  {
    id: 'casino-games',
    label: 'เล่นเกมส์คาสิโน',
    icon: Spade,
    children: [
      { href: '/soi-dao', label: 'สอยดาว', icon: Sparkles },
    ],
  },
  { href: '/leaderboard', label: 'ตารางอันดับ', icon: Trophy },
  { href: '/referrals', label: 'แนะนำเพื่อน', icon: Gift },
  { href: '/wallet', label: 'ฝาก-ถอน', icon: Wallet },
];

export function isNavActive(pathname, href) {
  if (href === '/') return pathname === '/';
  return pathname.startsWith(href);
}

export function isNavGroupActive(pathname, children = []) {
  return children.some((child) => isNavActive(pathname, child.href));
}

export { ChevronDown };
